import {
    CLEAR_MIX_DAILY_REPORTS,
    CLEAR_MIX_DAILY_LOADING,
    FETCH_MIX_DAILY_REPORTS,
    LIST_MIX_DAILY_REPORTS,
} from "./types";

const init = {
    isLoading: false,
    data: null,
    filter: {}
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MIX_DAILY_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_MIX_DAILY_REPORTS:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_MIX_DAILY_REPORTS:
            return {
                ...init
            };
        case CLEAR_MIX_DAILY_LOADING:
            return {
                ...state,
                isLoading: false,
            };
        default:
            return state;
    }
}